import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TableCheckAllComponent } from './table-check-all.component';
import { TableCheckRowComponent } from './table-check-row.component';

@NgModule({
  imports: [FormsModule, TableCheckAllComponent, TableCheckRowComponent],
  exports: [TableCheckAllComponent, TableCheckRowComponent],
})
export class TableCheckModule {}
